@if (isLoading$ | async) {
  <div class="spinner-container">
    <div class="spinner">Loading...</div>
  </div>
}
